import { useState, useEffect } from 'react';

import DOMPurify from "dompurify";

import './message.css';
import 'typeface-roboto';

import "@fontsource/poppins"; // Defaults to weight 400
import "@fontsource/poppins/400.css"; // Specify weight
import "@fontsource/poppins/400-italic.css"; // Specify weight and style

import user from '../../img/user.png';
import ai from '../../img/ai.png';

function Message({ message, who, smooth }){

    const [ text1, setText1 ] = useState('');

    
    useEffect(() => {
        const timeout = setTimeout(() => {
          if (text1 !== message) {
            setText1(message.slice(0, text1.length + 1));
          }
        }, 5);
      return () => {
        clearTimeout(timeout);
      }
    }, [ text1, message ]);

    const mySafeHTML = who === 'User' ? DOMPurify.sanitize(message, { ADD_TAGS: ["iframe"], ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'] }) : DOMPurify.sanitize(text1, { ADD_TAGS: ["iframe"], ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'] });

    return(
        <div className={who === 'User' ? 'container__UserMessage' : 'container__AIMessage'}>
            {who === 'AI' ? <div className='message__circle' style={{ marginRight: 10 }}> <img src={ai} alt='dataCourage' className='icon' /> </div> : <></>}
            <div className='message' style={{ fontFamily: 'Roboto' }}> 
              { smooth ? <div className='message--visible' dangerouslySetInnerHTML={{ __html: mySafeHTML.replace(/href/g, "target='_blank' href") }}/> : <div className='message--visible' dangerouslySetInnerHTML={{ __html: mySafeHTML.replace(/href/g, "target='_blank' href") }}/>}
              <div className='message--notVisible' dangerouslySetInnerHTML={{ __html: mySafeHTML.replace(/href/g, "target='_blank' href") }}/>
            </div>
            {who === 'User' ? <div className='message__circle' style={{ marginLeft: 10 }}> <img src={user} alt='user' className='icon' /> </div> : <></>}
        </div>
    )
}

export default Message;